<template>
    <div :class="$style.item">
        <p class="black fs32 fw500 mb30">{{ head }}</p>
        <p class="gray fs18">{{ content }}</p>
    </div>
</template>
<script>
export default {
    name: 'lay1',
    props: {
        head: {type: String, default: ''},
        content: {type: String, default: ''},
    }
}
</script>
<style module>
@media screen and (min-width: 770px) {
.item {
    max-width: 350px;
}
}
</style>
